import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Flame } from "lucide-react";
import api, { imgUrl } from "../lib/api";
import { ShowStageCard } from "../components/ShowStageCard";
import { CardSkeletonList, EmptyState } from "../components/Common";
import { BookedStrip } from "../components/BookedStrip";
import { useAuth } from "../context/AuthContext";

export default function CategoryGames() {
  const { name } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const cat = decodeURIComponent(name || "");
  const [games, setGames] = useState([]);
  const [bets, setBets] = useState([]);
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(true);

  const loadGames = useCallback(() => api.get("/games").then((g) => setGames(g.data.filter((x) => (x.category || "") === cat))).catch(() => {}), [cat]);
  useEffect(() => {
    setLoading(true);
    Promise.all([api.get("/games"), api.get("/config")]).then(([g, c]) => {
      setGames(g.data.filter((x) => (x.category || "") === cat));
      setImage((c.data.category_images || {})[cat] || "");
    }).catch(() => {}).finally(() => setLoading(false));
  }, [cat]);
  useEffect(() => { const t = setInterval(loadGames, 60000); return () => clearInterval(t); }, [loadGames]);
  useEffect(() => {
    if (!user) { setBets([]); return; }
    api.get("/bets/my", { params: { tab: "current" } }).then((r) => setBets(r.data || [])).catch(() => {});
  }, [user, cat]);

  return (
    <div className="space-y-4 pb-6">
      <button onClick={() => navigate(-1)} className="flex items-center gap-1 text-slate-500 text-sm font-medium" data-testid="category-back-btn"><ArrowLeft className="w-4 h-4" />Back</button>
      <BookedStrip games={games} bets={bets} testId="category-booked-strip" />

      <div className="relative rounded-2xl overflow-hidden h-28 rl-gold-border" data-testid="category-hero">
        {image ? <img src={imgUrl(image)} alt={cat} className="absolute inset-0 w-full h-full object-cover" /> : <div className="absolute inset-0 rl-gold-bg" />}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-transparent flex items-end p-4">
          <div>
            <h1 className="text-white font-display font-black text-2xl drop-shadow">{cat}</h1>
            <span className="text-amber-300 text-xs font-semibold">{games.length} draws available</span>
          </div>
        </div>
      </div>

      <h2 className="font-display font-bold text-slate-900 flex items-center gap-2"><Flame className="w-4 h-4 text-blue-600" />Draws & Timings</h2>
      {loading ? <CardSkeletonList count={4} /> : games.length === 0 ? (
        <EmptyState title="No draws" subtitle="No draws in this category yet." />
      ) : (
        <div className="space-y-3" data-testid="category-games-list">
          {games.map((g) => <ShowStageCard key={g.id} game={g} onClosed={() => setTimeout(loadGames, 1500)} />)}
        </div>
      )}
    </div>
  );
}
